"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconGraphDown = void 0;

var React = __importStar(require("react"));

exports.IconGraphDown = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "36",
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M40 34.582C40 35.2734 39.4395 35.832 38.75 35.832H3.334C1.4961 35.832 0 34.3359 0 32.498V1.25C0 0.5586 0.56055 0 1.25 0C1.93945 0 2.5 0.5586 2.5 1.25V32.5C2.5 32.9609 2.875 33.334 3.334 33.334H38.75C39.4395 33.332 40 33.8906 40 34.582ZM8.7695 5.9885C9.08786 5.9885 9.40815 6.11154 9.6523 6.35568L18.9708 15.6742C19.295 15.9984 19.8243 15.9984 20.1505 15.6742L23.3575 12.4671C24.6153 11.2093 26.8126 11.2093 28.0704 12.4671L36.623 21.0196V17.006C36.623 16.3146 37.1835 15.756 37.873 15.756C38.5624 15.756 39.123 16.3165 39.123 17.006L39.121 24.037C39.121 24.1991 39.0878 24.3612 39.0253 24.5135C38.8983 24.8202 38.6542 25.0643 38.3495 25.1913C38.1971 25.2538 38.035 25.287 37.8729 25.287H30.8419C30.1525 25.287 29.5919 24.7264 29.5919 24.037C29.5919 23.3475 30.1525 22.787 30.8419 22.787H34.8556L26.3046 14.236C25.9804 13.9118 25.4511 13.9118 25.1249 14.236L21.9178 17.443C20.619 18.7438 18.5038 18.7438 17.2049 17.443L7.88643 8.12455C7.39815 7.63627 7.39815 6.84525 7.88643 6.355C8.13057 6.11086 8.4492 5.9885 8.7695 5.9885Z",
    fill: color
  }));
});